import React from "react";
import LegalPage from "@/pages/LegalPage";

export default function CookiePolicyPage() {
  return <LegalPage nsKey="cookies" testid="cookies-page" sectionCount={6} />;
}
